import { Menu, MenuProps, Typography } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useContextUsers } from '../../../../../context/users';
import { sideMenuRoutes } from '../../../../../routes/sideMenu';
import { useAuth } from '../../../../../context/auth';

type MenuItem = Required<MenuProps>['items'][number];

function MenuCommon(): JSX.Element | null {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { profile } = useContextUsers();
  const { checkSubscriptionValidity } = useAuth();

  const [key, setKey] = useState('');

  const permissions = profile && profile.permissions ? JSON.parse(profile.permissions) : {};
  const keys = Object.keys(permissions);

  const filteredRoutes =
    profile?.type === 'admin'
      ? sideMenuRoutes
      : sideMenuRoutes.filter((route) => route.isEssential || (route.name && keys.includes(route.name)));

  useEffect(() => {
    setKey(pathname.split('/').find((item) => !!item) || '');
  }, [pathname]);

  useEffect(() => {
    const currentRoute = filteredRoutes.find((route) => route.bind.path === `/${key}`);

    if (
      currentRoute?.privateRoute &&
      currentRoute.isSubscriptionNeeded &&
      !checkSubscriptionValidity?.()
    ) {
      navigate('/setup', { replace: true });
    }
  }, [key]);

  if (!key) {
    return null;
  }

  const getItem = (
    label: React.ReactNode,
    itemKey?: React.Key | null,
    icon?: React.ReactNode,
    children?: MenuItem[],
    disabled?: boolean
  ): MenuItem =>
    ({
      key: itemKey,
      icon,
      children,
      label,
      disabled,
    } as MenuItem);

  return (
    <Menu
      mode="inline"
      selectedKeys={[pathname, `/${key}`]}
      defaultOpenKeys={[`/${key}`]}
      defaultSelectedKeys={[pathname, `/${key}`]}
      items={filteredRoutes.map((route) => {
        const children = route.children
          ?.filter(({ hidden }) => !hidden)
          ?.map((subRoute) =>
            getItem(
              subRoute.isSubscriptionNeeded && !checkSubscriptionValidity?.() ? (
                <Typography className="color-gray">{subRoute.name}</Typography>
              ) : (
                <Link aria-disabled to={`${route.bind.path}${subRoute.bind.path}`}>
                  {subRoute.name}
                </Link>
              ),
              `${route.bind.path}${subRoute.bind.path}`,
              subRoute.icon
            )
          );

        return getItem(
          <div className="flex-row flex-justify-space-between flex-align-center">
            <Link className="flex-1" to={route.bind.path || '/'}>
              {route.name}
            </Link>

            {!!route?.suffix && route.suffix}
          </div>,
          route.bind.path,
          route.icon,
          children?.length ? children : undefined,
          route.isSubscriptionNeeded && !checkSubscriptionValidity?.()
        );
      })}
    />
  );
}

export default MenuCommon;
